import { render, staticRenderFns } from "./UiDataTable.vue?vue&type=template&id=737e5a90"
import script from "./UiDataTable.vue?vue&type=script&lang=js"
export * from "./UiDataTable.vue?vue&type=script&lang=js"
import style0 from "./UiDataTable.vue?vue&type=style&index=0&id=737e5a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports